<!-- Info and Detail Row -->
<div
  class="flex min-h-[70px] flex-col justify-center border border-t-0 p-4 text-aux-black"
  [ngClass]="{ 'bg-aux-gray-light': open }"
>
  <!-- Info Row -->
  <div class="flex w-full items-center space-x-[20px]">
    <!-- Dropdown Icon -->
    <div class="mr-2" [style.cursor]="disabledRow ? 'default' : 'pointer'">
      @if (!open && disabledRow) {
        <aux-icon name="ChevronDown" style="color: lightgray" />
      }
      @if (!open && !disabledRow) {
        <aux-icon name="ChevronDown" (click)="toggleRow()" />
      }
      @if (open) {
        <aux-icon name="ChevronUp" (click)="toggleRow()" />
      }
    </div>

    @switch (title) {
      @case (rowTitles.GatherContracts) {
        <aux-gather-contract-row-title class="!ml-0" />
      }
      @case (rowTitles.ForecastCurves) {
        <aux-forecast-curves-row-title class="!ml-0" />
      }
      @case (rowTitles.GatherInvoices) {
        <aux-gather-invoices-row-title class="!ml-0" [selectedMonth]="selectedMonth" />
      }
      @default {
        <div class="!ml-0 flex-grow">
          @if (route) {
            <span
              class="btn--hyperlink cursor-pointer px-0"
              [routerLink]="[customRoute() || route]"
              [queryParams]="queryParams"
            >
              {{ title }}
            </span>
          }
          @if (!route) {
            <span class="checklist-row-info-title">{{ title }}</span>
          }
        </div>
      }
    }

    <!-- Displays extra columns (specific to each checklist item) -->
    @if (workflow) {
      <ng-content></ng-content>
    }

    <!-- Monthly Review Notes Counter -->
    @if (originalWorkflow) {
      <div class="flex shrink-0 items-center justify-center">
        <aux-monthly-review-notes-counter
          [workflow$]="workflow$"
          [opened$]="opened$"
          (clicked)="toggleRow()"
        />
      </div>
    }

    <!-- Last Update -->
    @if (originalWorkflow && !isChecklistTimestampEnabled()) {
      <div class="w-28 shrink-0">
        <div class="text-sm">Last Update</div>

        <div>
          {{ originalWorkflow.last_update_date | date }}
        </div>
      </div>
    }

    <!-- Last Update for QA Testing. Will only appear if feature flag is on -->
    @if (originalWorkflow && isChecklistTimestampEnabled()) {
      <div class="w-28 shrink-0">
        <div class="text-sm">Last Update</div>

        <div>
          {{ originalWorkflow.last_update_date | date: 'MMM d, y HH:mm' }}
        </div>
      </div>
    }

    <!-- Updated by -->
    @if (originalWorkflow) {
      <div class="w-28 shrink-0">
        <div class="text-sm">Updated by</div>

        <aux-first-name-show
          [text]="originalWorkflow.last_updated_by_full_name"
          [showHyphenIfEmpty]="true"
        />
      </div>
    }

    <!-- Locked by -->
    @if (workflow && locked) {
      <div class="w-36 shrink-0">
        <div class="text-sm">Locked by</div>

        <aux-first-name-show [text]="lockedBy" [showHyphenIfEmpty]="true" />
      </div>
    }

    <!-- Assign To -->
    @if (workflow && !locked) {
      <div class="grid w-36 shrink-0">
        <div class="text-sm">Assign To</div>
        @if (isAdmin || checklistAdminPermission) {
          <ng-select
            placeholder="Select User"
            [clearable]="true"
            [formControl]="assignToFormControl"
            (change)="changeAssign(workflow)"
          >
            @if (externalUserWithPermissionsList$ | async; as usersList) {
              @for (user of usersList; track user.sub) {
                <ng-option [value]="user.sub">
                  <aux-first-name-show
                    [text]="
                      (user.given_name + ' ' + user.family_name).length > 30
                        ? (user.given_name + ' ' + user.family_name).substring(0, 30)
                        : user.given_name + ' ' + user.family_name
                    "
                    [showHyphenIfEmpty]="true"
                  />
                </ng-option>
              }
            }
          </ng-select>
        } @else {
          <aux-first-name-show [text]="user ? user : zeroHyphen" [showHyphenIfEmpty]="true" />
        }
      </div>
    }

    <!-- Date Locked -->
    @if (workflow) {
      <div class="w-28 shrink-0">
        <div class="text-sm">Date Locked</div>

        <div>
          {{ locked ? (lockedDate | date) : zeroHyphen }}
        </div>
      </div>
    }

    @if (locked && workflow) {
      <div
        class="w-28 shrink-0 pr-7"
        [attr.data-pendo-id]="
          this.title === rowTitles.GatherContracts
            ? 'site-contracts-change-orders-unlock'
            : this.title === rowTitles.GatherInvoices
              ? 'review-invoices-unlock'
              : this.title === rowTitles.GatherEstimates
                ? 'review-vendor-estimates-unlock'
                : this.title === rowTitles.GatherPatients
                  ? 'confirm-patient-data-unlock'
                  : this.title === rowTitles.ForecastTimeline
                    ? 'confirm-trial-timeline-unlock'
                    : this.title === rowTitles.ForecastCurves
                      ? 'site-and-patient-curves-unlock'
                      : this.title === rowTitles.ForecastMethodology
                        ? 'forecast-methodology-unlock'
                        : this.title === rowTitles.CloseExpenses
                          ? 'confirm-vendor-expenses-unlock'
                          : this.title === rowTitles.CloseDiscounts
                            ? 'confirm-discounts-unlock'
                            : ''
        "
        [auxTooltip]="getUnlockBtnTooltip()"
      >
        <aux-button
          [disabled]="!hasUserPermissions || disabledLock"
          (clickEmit)="changeLockStatus(false, workflow, false)"
          icon="Check"
          label="Unlock"
          variant="hyperlink"
          classList="flex-col"
          svgAttributes="text-aux-green-dark"
        />
      </div>
    }

    @if (!locked && workflow) {
      <div class="w-28 shrink-0">
        <div
          class="mr-6 flex"
          [attr.data-pendo-id]="
            this.title === rowTitles.GatherContracts
              ? 'site-contracts-change-orders-lock'
              : this.title === rowTitles.GatherInvoices
                ? 'review-invoices-lock'
                : this.title === rowTitles.GatherEstimates
                  ? 'review-vendor-estimates-lock'
                  : this.title === rowTitles.GatherPatients
                    ? 'confirm-patient-data-lock'
                    : this.title === rowTitles.ForecastTimeline
                      ? 'confirm-trial-timeline-lock'
                      : this.title === rowTitles.ForecastCurves
                        ? 'site-and-patient-curves-lock'
                        : this.title === rowTitles.ForecastMethodology
                          ? 'forecast-methodology-lock'
                          : this.title === rowTitles.CloseExpenses
                            ? 'confirm-vendor-expenses-lock'
                            : this.title === rowTitles.CloseDiscounts
                              ? 'confirm-discounts-lock'
                              : ''
          "
          [auxTooltip]="getLockBtnTooltip()"
        >
          <aux-button
            [disabled]="!hasUserPermissions || disabledLock"
            (clickEmit)="changeLockStatus(true, workflow, false)"
            icon="Lock"
            label="Lock"
          />
        </div>
      </div>
    }
  </div>

  <!-- Detail Row -->
  @if (checklistComponent && open && workflow) {
    <div [ngClass]="detailRowContainerClassName">
      <ng-template checklistComponentHost></ng-template>
    </div>
  }
  @if (open) {
    <aux-checklist-notes
      [checklistAdminPermission]="checklistAdminPermission"
      [workflow$]="workflow$"
    />
  }
</div>
